"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var random_bytes = function (length) {
    if (typeof window !== 'undefined' && window.crypto) {
        var buffer = new ArrayBuffer(length);
        var buffer_view = new Uint8Array(buffer);
        return window.crypto.getRandomValues(buffer_view);
    }
    else {
        var crypto_1 = require('crypto');
        return new Uint8Array(crypto_1.randomBytes(length));
    }
};
exports.default = { random_bytes: random_bytes };



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/util/RandomUtil.js
// module id = 117
// module chunks = 0 1